var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-404"},[_c('div',{staticClass:"ml-404-warp"},[_c('div',{staticClass:"img-404"}),_c('div',{staticClass:"word-404"},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("首页 "),_c('i',{staticClass:"el-icon-back"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }